<template>
  <v-card>
    <v-card-title>
      <h5>{{ title }}</h5>
    </v-card-title>
    <v-form ref="form" @submit.prevent="submit">
      <v-container fluid>
        <v-layout>
          <v-flex xs4>
            <v-text-field
              class="validate"
              prepend-icon="home"
              v-model="lastName"
              label="Nom"
              :rules="[v => !!v || 'Le nom est requis']"
              required
            />
          </v-flex>
          <v-flex xs4 class="ml-10">
            <v-text-field
              class="validate"
              prepend-icon="person"
              v-model="firstName"
              label="Prénom"
              :rules="[v => !!v || 'Le prénom est requis']"
              required
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex :xs8="!userCreatorSuperAdmin" :xs4="userCreatorSuperAdmin">
            <v-text-field
              class="validate"
              prepend-icon="email"
              v-model="email"
              label="E-mail"
              :rules="emailRules"
              required
            />
          </v-flex>
          <v-flex
            v-if="userCreatorSuperAdmin"
            class="d-flex flex-row align-center ml-10"
            xs5
          >
            <v-select
              class="d-flex flex-grow-1 mr-5"
              v-model="cooperative"
              :items="parsedCooperatives"
              prepend-icon="mdi-home-city"
              label="Cooperative"
              menu-props="auto"
              :rules="[v => !!v || 'Une cooperative doit être séléctionné']"
              required
            />
            <coop-form
              :showModal="showCreateCoopModal"
              @closeModal="setCooperativeIfCreate"
            >
              <v-btn @click="showCreateCoopModal = true" color="indigo" dark>
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </coop-form>
          </v-flex>
        </v-layout>
        <v-layout v-if="noFlag === false">
          <v-flex xs3>
            <v-select
              label="Habilitation"
              prepend-icon="how_to_reg"
              v-model="currentAuthorizations"
              :items="allAuthorizations"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="mt-5">
            <template v-if="user">
              <v-btn class="scdf-yellow mr-2" type="submit">
                <v-icon>edit</v-icon>
                Valider
              </v-btn>
              <v-btn class="scdf-red" @click="close" type="reset">
                <v-icon>clear</v-icon>
                Annuler
              </v-btn>
            </template>
            <template v-else>
              <v-btn class="scdf-yellow mr-2" type="submit">
                <v-icon>add</v-icon>
                Ajouter
              </v-btn>
              <v-btn class="scdf-red" @click="initialize">
                <v-icon>clear</v-icon>
                Effacer
              </v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
// import Boolean from "../Boolean"
import { mapState } from 'vuex';
import CoopForm from '@/components/Form/CoopForm';

export default {
  name: 'user-form',
  components: {
    CoopForm,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    userCreatorId: {
      type: Number,
      default: null,
    },
    userCreatorSuperAdmin: {
      type: Boolean,
      default: false,
    },
    noFlag: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['cooperatives']),
    dateNull: {
      get() {
        return this.user.dateDebutAction === null;
      },
    },
    parsedCooperatives() {
      const parsedCooperatives = [];
      if (this.cooperatives) {
        this.cooperatives.forEach(item => {
          parsedCooperatives.push({
            value: {
              id: item.id,
            },
            text: item.nom,
          });
        });
      }
      return parsedCooperatives;
    },
  },
  data() {
    return {
      showCreateCoopModal: false,
      lastName: null,
      firstName: null,
      email: null,
      cooperative: null,
      adminId: null,
      currentAuthorizations: null,
      allAuthorizations: [
        {
          text: 'aucune habilitation',
          value: [false, false],
        },
        {
          text: 'import seulement',
          value: [true, false],
        },
        {
          text: 'import et optimisation',
          value: [true, true],
        },
      ],
      emailRules: [
        v => !!v || "L'email est requis",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "L'email doit être valide",
      ],
    };
  },
  methods: {
    initialize() {
      if (this.user) {
        // IF EDITING AN EXISTING USER

        if (this.userCreatorSuperAdmin) {
          this.lastName = this.user.lastName;
          this.firstName = this.user.firstName;
          this.email = this.user.email;
          this.cooperative = this.user.cooperative;
          this.currentAuthorizations = [
            this.user.habImport,
            this.user.habOptim,
          ];
        } else {
          this.lastName = this.user.lastName;
          this.firstName = this.user.firstName;
          this.email = this.user.email;
          this.cooperative = this.user.cooperative;
        }
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form && this.$refs.form.validate()) {
        const authorizationFlags = {
          importing: false,
          optimizing: false,
        };
        const ca = this.currentAuthorizations;
        if (ca !== null) {
          if (ca[0] === true && ca[1] === false) {
            // import
            authorizationFlags.optimizing = true;
          } else if (ca[0] === false && ca[1] === false) {
            authorizationFlags.importing = true;
            authorizationFlags.optimizing = true;
          }
        }

        let argUser = {};
        if (this.user) {
          if (this.userCreatorSuperAdmin) {
            argUser = {
              lastName: this.lastName,
              firstName: this.firstName,
              email: this.email,
              cooperative: this.cooperative,
              adminId: this.user.adminId,
              ...authorizationFlags,
            };
          } else {
            argUser = {
              lastName: this.lastName,
              firstName: this.firstName,
              email: this.email,
            };
          }
        } else {
          argUser = {
            lastName: this.lastName,
            firstName: this.firstName,
            email: this.email,
            cooperative: this.cooperative,
            adminId: this.userCreatorSuperAdmin ? null : this.userCreatorId,
            minsLongImport: 0,
          };
        }
        this.$emit(
          this.user ? 'edit' : 'submit',
          argUser,
          this.user ? this.user.id : null
        );
        this.lastName = null;
        this.firstName = null;
        this.email = null;
        this.adminId = null;
        this.cooperative = null;
        this.currentAuthorizations = null;
        this.close();
      }
    },
    setCooperativeIfCreate(data) {
      this.showCreateCoopModal = false;
      if (data && data.cooperative) {
        this.cooperative = {
          id: data.cooperative.id,
        };
      }
    },
    close() {
      this.initialize();
      this.$emit('close-expansion');
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
.checkbox-field {
  display: flex;
  height: 100%;
  overflow: visible;
  flex-direction: column;
  justify-content: center;

  ::v-deep .v-input__slot {
    margin: 24px;
  }
}
</style>
